import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
// import axios from "axios";

export default {
  name: 'TermsOfUseModal',
  extends: BaseModal,
  data: function () {
    return {
      lang: '',
    }
  },
  mounted() {
    this.lang = window.localStorage.getItem('lang_locale')
  },
  // mounted() {
  //   this.fetchQr();
  // },
  // methods: {
  //   fetchQr() {
  //     this.blocker = true;
  //     axios({
  //       method: 'get',
  //       url: `boxes/${this.data.boxId}/access_qr?data_url=1`
  //     })
  //     .then(response => {
  //       this.qrCode = response.data;
  //       this.blocker = false;
  //       console.log("createDeliveryRequest response", response.data);
  //     })
  //     .catch(error => {
  //       this.blocker = false;
  //       console.error("createDeliveryRequest error", error.response);
  //     });
  //   }
  // },
  components: {
    TermsPl: () => import('./terms-pl/cmp.vue'),
    TermsEn: () => import('./terms-en/cmp.vue'),
  },
}
